import config from '@/config';

export const ticketListPage = {
  breadcrumb: [{ name: 'Ticket List', url: '#' }],
  pageInfo: 'Ticket list',
  backUrl: `${config.contextPath}/ticket`,
};
export const ticketPage = {
  breadcrumb: [
    {
      name: 'Ticket List',
      url: `${config.contextPath}/ticket`,
    },
    {
      name: 'Ticket Detail',
      url: '#',
    },
  ],
  pageInfo: 'Ticket detail',
  backUrl: `${config.contextPath}/ticket`,
};
